import React,{useState,useEffect} from 'react';
import TodoWhite from './img/3.png'
import TodoDark from './img/2.png'
import BlackJack from './img/1.jpg'
import books from './img/books.png'
import styles from './Portfolio.module.scss'


const Portfolio = (props) => {
    const [stat,setStat]=useState(false)
    const title = 'Портфолио'

    const OnClick = (url)=>{
        window.open(url)
    }


    useEffect(()=>{
       const x =  setInterval(()=>{
            setStat((s)=>{
                return !s
            })

        },2000)
        return ()=>{
           clearInterval(x)
        }
    },[])

    let imgg = stat?TodoWhite:TodoDark
    const items = [
        {name:'TodoList',img:imgg,url:'https://pioner92.github.io/Todo-List-White-Dark/'},
        {name:'Игра 21 (BlackJack)',img:BlackJack,url:'https://pioner92.github.io/BlackJack-Game-link/'},
        {name:'Книжный магазин (M.E.R.N)',img:books,url:'https://books-b695c.web.app/'}
    ]
    return (
        <React.Fragment>
            <div><h2>{title}</h2></div>

            <div className={styles.portfolio}>
                {
                    items.map((el,index)=>{
                        return(
                            <div key={index}>
                                <img onClick={()=>{OnClick(el.url)}} src={el.img} alt=""/>
                                <span onClick={()=>{OnClick(el.url)}}>{el.name}</span>
                            </div>
                        )
                    })
                }
            </div>
        </React.Fragment>
    );
};

export default Portfolio;
